import { Injectable } from '@angular/core';

interface LogoBank {
  [key: string]: string;
}

@Injectable({providedIn: 'root'})
export class ProductLogoBankService {
  bank: LogoBank = {};

  storeLogo(productId: string, logoUrl: string): void {
    this.bank[productId] = logoUrl;
  }

  getLogo(productId: string): string {
    return this.bank[productId];
  }
}
